export enum AttributeTypeEnum {
  STRING = "string",
  TEXT = "text",
  DATE = "date",
  EMAIL = "email",
  PHONE = "phone",
  NUMBER = "number",
  TIME = "time",
}

export const AttributeTypeList = Object.values(AttributeTypeEnum);

export type CreateOrAssignAttribute = {
  label: string;
  value: string | number;
  type: AttributeTypeEnum;
  attributeId: string;
};

export type ConversationAttributeAssign = {
  conversationId: string;
  agentId: string;
  attributeId: string;
  value: string;
};

export type ConversationAttributeUnassign = {
  conversationId: string;
  agentId: string;
  attributeId: string;
};

export type ConversationAttributeCreateEmit = {
  agentId: string;
  label: string;
  type: AttributeTypeEnum;
};

export type ConversationAttributeListEmit = {
  conversationId: string;
  agentId: string;
  page: number;
  limit: number;
  search: string;
};

export type Attribute = {
  id: string;
  label: string;
  type: AttributeTypeEnum;
  meta: null;
  projectId: string;
  createdAt: string;
  updatedAt: string;
};

export type AttributePagination = {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasMore: boolean;
};

export type ConversationAttributeListResponse = {
  meta: AttributePagination;
  data: Attribute[];
};
